"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import Auth from "../util/auth";
import Api from "../api/api";
import ExceptionSender from "./exception_sender";
import LoadEmailCreator from "./load_email_creator";
import FactorInvoicesService from "./factor_invoices_service";
import CarrierService from "../services/carrier_service";
import WaitingSpinner from "../components/waiting_spinner";
function findEmail(props, emailMessages) {
  if (props.emailId) {
    return emailMessages.find((e) => e.id === props.emailId) || null;
  }
  return emailMessages[0] || null;
}
var ExceptionSenderWrapper = React.createClass({
  getInitialState: function() {
    return {
      loading: true,
      factorInvoice: null,
      carrier: null,
      documents: [],
      email: null,
      error: null
    };
  },
  componentDidMount: function() {
    this.fetchData();
  },
  fetchData: function() {
    FactorInvoicesService.fetchWithID(this.props.factorInvoiceId).then(
      (data) => {
        const factorInvoice = data.factor_invoice;
        const documents = data.documents || [];
        const email = findEmail(this.props, factorInvoice.email_messages || []);
        const carrierId = factorInvoice.carrier_id || factorInvoice.tms_carrier_id;
        if (carrierId) {
          CarrierService.carrierWithId(carrierId).then(
            (carrier) => {
              this.setState({
                loading: false,
                factorInvoice,
                carrier,
                documents,
                email
              });
            },
            () => {
              this.setState({
                loading: false,
                factorInvoice,
                carrier: null,
                documents,
                email
              });
            }
          );
        } else {
          this.setState({
            loading: false,
            factorInvoice,
            carrier: null,
            documents,
            email
          });
        }
      },
      (error) => {
        this.setState({ loading: false, error: "Failed to load invoice data" });
        return Promise.reject(error);
      }
    );
  },
  render: function() {
    var _a;
    if (this.state.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
    if (this.state.error) {
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__error" }, this.state.error);
    }
    const { factorInvoice, carrier, documents, email } = this.state;
    if (!(factorInvoice == null ? void 0 : factorInvoice.active_exceptioned_item)) {
      return /* @__PURE__ */ React.createElement("div", { className: "exception-sender__error" }, "No active exception found for this invoice.");
    }
    const settings = Api.Account.currentSettings() || {};
    const templateVariables = (_a = Api.Account.current()) == null ? void 0 : _a.payables_template_variables;
    const { queuedMessages } = this.props;
    const invoiceForTemplate = queuedMessages.length > 0 ? __spreadProps(__spreadValues({}, factorInvoice), {
      exception_events: queuedMessages.map((msg) => ({
        message_override: msg
      })),
      failure_messages: []
    }) : factorInvoice;
    const defaultEmail = new LoadEmailCreator(
      null,
      invoiceForTemplate,
      Auth._currentUser,
      settings.custom_exception_email_subject_template || "",
      settings.custom_exception_email_body_template || "",
      templateVariables || [],
      carrier
    ).initialEmail();
    return /* @__PURE__ */ React.createElement(
      ExceptionSender,
      {
        documents,
        onComplete: this.props.onComplete,
        defaultEmail,
        parent: email,
        parentId: email == null ? void 0 : email.id,
        contacts: (carrier == null ? void 0 : carrier.contacts) || [],
        canCancel: true,
        cancel: this.props.onCancel,
        exceptionedItemId: factorInvoice.active_exceptioned_item.id,
        carrierInvoice: factorInvoice,
        carrier,
        multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
        customEmailTemplates: settings.custom_exception_email_templates,
        templateVariables
      }
    );
  }
});
export default ExceptionSenderWrapper;
